﻿import { supabase } from './supabase';

export interface UploadResponse {
  ok: true;
  document_id: string;
  filename: string;
}

export interface UploadErrorResponse {
  ok: false;
  error: string;
}

export type UploadResult = UploadResponse | UploadErrorResponse;

const ACCEPTED_TYPES = [
  'application/pdf',
  'image/png',
  'image/jpeg',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export function isValidFileType(mimeType: string): boolean {
  return ACCEPTED_TYPES.includes(mimeType);
}

export async function uploadDocument(fileUri: string, fileName: string, mimeType: string): Promise<UploadResult> {
  try {
    const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
    if (sessionError || !sessionData.session) {
      return { ok: false, error: 'Utilisateur non authentifié' };
    }

    if (!isValidFileType(mimeType)) {
      return { ok: false, error: 'Format non supporté. Utilisez PDF, PNG, JPG, PPT, PPTX ou DOCX.' };
    }

    const formData = new FormData();
    formData.append('file', {
      uri: fileUri,
      name: fileName,
      type: mimeType,
    } as any);

    const { data, error } = await supabase.functions.invoke('upload', {
      body: formData,
    });

    if (error) {
      console.error('Upload error:', error);
      return { ok: false, error: error.message || "Erreur lors de l'upload" };
    }

    if (data?.document_id) {
      await supabase.functions.invoke('process-document', {
        body: { document_id: data.document_id },
      });

      console.log('Document uploaded, ID:', data.document_id);

      return {
        ok: true,
        document_id: data.document_id,
        filename: fileName,
      };
    }

    return { ok: false, error: 'Aucun document_id retourné' };
  } catch (error: any) {
    console.error('Upload exception:', error);
    return { ok: false, error: error.message || 'Une erreur est survenue' };
  }
}